<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" :label="$tt('充电站:')" :label-width="100">
				<Select filterable :placeholder="$tt('站点列表')" style="width: 200px;" v-model="formInline.StationId">
					<Option :value=0>{{$tt('全部')}}</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.OrderNo" :placeholder="$tt('订单单号')">
				<span slot="prepend">{{$tt('订单单号')}}</span>
				</Input>
			</FormItem>
			<!-- <FormItem :label="$tt('开始时间')" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeBegin"></DatePicker>
			</FormItem> -->
			<!-- <FormItem :label="$tt('结束时间')" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeEnd"></DatePicker>
			</FormItem> -->
			<FormItem :label="$tt('选择时间')" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			<FormItem>
				<Input type="text" v-model="formInline.MemberName" :placeholder="$tt('会员名称')">
				<span slot="prepend">{{$tt('会员名称')}}</span>
				</Input>
			</FormItem>
			<FormItem>
				<Input type="text" v-model="formInline.EquipmentNo" :placeholder="$tt('设备编号')">
				<span slot="prepend">{{$tt('设备编号')}}</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">{{$tt('导出文件')}}</Button>
			</FormItem>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight" ref="ChargingOrder"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getEvcsChargeOrderUrl" @listData='getDeviceData'></MyPage>
		<echartModal ref="echartModal" curvesName="EvcsChargeOrder"></echartModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import echartModal from '../../public/CurvesTemplate/ChargingOrderEchart.vue'
	import Qs from 'qs'
	import expandRow from './EvcsChargeOrderTemplate/EvcsChargeOrderExpand.vue';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		components: {
			echartModal
		},
		data() {
			return {
				getEvcsChargeOrderUrl: webapi.base_api_url + '/Order/GetEvcsChargeOrder',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "有家充电站",
				tableHeight: "650",
				modal: {
					Title: this.$tt('设备信息添加'),
					type: "addDevice"
				},
				BreadcrumbList: [this.$tt('订单记录'), '>>', this.$tt('互联互通订单')],
				formInline: {
					StationId: 0,
					OrderNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
					MemberName: '',
					EquipmentNo: ''
				},
				//table标题数据
				columns1: [{
						type: 'expand',
						width: 50,
						render: (h, params) => {
							return h(expandRow, {
								props: {
									row: params.row
								}
							})
						}
					}, {
						title: this.$tt('订单单号'),
						key: 'OrderNo',
						minWidth: 120,
					}, {
						title: this.$tt('订单时间'),
						key: 'OrderTime',
						minWidth: 120,
					},
					{
						//title: '订单来源',
						title: this.$tt('流量方运营商'),
						key: 'EvcsOperatorName',
						minWidth: 120,
						// render: (h, params) => {
						// 	return h('div', params.row.EvcsOperatorName);
						// }
					},
					{
						title: this.$tt('订单状态'),
						key: 'OrderStatus',
						minWidth: 120,
						render: (h, params) => {
							return h('div', params.row.OrderStatusDesc);
						}
					},
					// {
					// 	title: '会员手机号码',
					// 	key: 'MemberPhone',
					// 	minWidth: 120,
					// },
					{
						title: this.$tt('同步状态'),
						key: 'SyncStatusDesc',
						minWidth: 120,
					},
					// {
					// 	title: '预付金额(元)',
					// 	key: 'OrderAmount',
					// 	minWidth: 120,
					// },
					{
						title: this.$tt('充电总费用(元)'),
						key: 'ChargeCost',
						minWidth: 120,
					},
					// {
					// 	title: '优惠金额',
					// 	key: 'CouponAmount',
					// 	minWidth: 120,
					// },
					// {
					// title: '结算金额',
					// 	key: 'CouponCost',
					// 	minWidth: 120,
					// },
					{
						title: this.$tt('枪编号'),
						key: 'ConnectorNo',
						minWidth: 120,
					},
					{
						title: this.$tt('站点名称'),
						key: 'StationName',
						minWidth: 120,
					},
					{
						title: this.$tt('站点运营商'),
						key: 'LocalOperatorName',
						minWidth: 120,
					},
					{
						title: this.$tt('操作'),
						key: 'action',
						align: 'center',
						minWidth: 200,
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('chargeCurves') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("view", params.row.OrderNo)
										}
									}
								}, this.$tt('充电曲线')) : h(),
								this.hasWidgets('push') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											if (params.row.OrderStatusDesc === "结算完成") {
												this.$Modal.confirm({
													title: this.$tt('订单号:') + params.row.OrderNo,
													okText: this.$tt('取消'),
													cancelText: this.$tt('确定'),
													onCancel: () => {
														this.otherMethod(params.row
															.OrderNo);
													}
												});
											} else {
												this.$Modal.warning({
													title: this.$tt('未结算完成订单'),
													okText: this.$tt('取消'),
													//cancelText: '关闭',
												});
											}
										}
									}
								}, this.$tt('重新推送')) : h(),
							]);
						}
					}
				],
				columns2: [{
						title: this.$tt('订单单号'),
						key: 'OrderNo',
					}, {
						title: this.$tt('订单时间'),
						key: 'OrderTime',
					},
					{
						title: this.$tt('订单来源'),
						key: 'TradeType',
						render: (h, params) => {
							return h('div', params.row.TradeTypeDesc);
						}
					},
					{
						title: this.$tt('订单状态'),
						key: 'OrderStatus',
						render: (h, params) => {
							return h('div', params.row.OrderStatusDesc);
						}
					},
					{
						title: this.$tt('流量方运营商'),
						key: 'EvcsOperatorName',
						render: (h, params) => {
							return h('div', params.row.EvcsOperatorName);
						}
					},
					// {
					// 	title: '会员手机号码',
					// 	key: 'MemberPhone'
					// },
					{
						title: this.$tt('同步状态'),
						key: 'SyncStatusDesc'
					},
					{
						title: this.$tt('预付金额(元)'),
						key: 'OrderAmount'
					},
					{
						title: this.$tt('充电总费用(元)'),
						key: 'ChargeCost'
					},
					// {
					// 	title: '优惠金额',
					// 	key: 'CouponAmount'
					// },
					// {
					// 	title: '结算金额',
					// 	key: 'CouponCost'
					// },
					{
						title: this.$tt('枪编号'),
						key: 'ConnectorNo'
					},
					{
						title: this.$tt('站点名称'),
						key: 'StationName'
					},
					{
						title: this.$tt('充电电费(元)'),
						key: 'ElecCost'
					},
					{
						title: this.$tt('充电服务费(元)'),
						key: 'ServiceCost'
					},
					{
						title: this.$tt('充电电量(度)'),
						key: 'ChargeKwh'
					},
					{
						title: this.$tt('起始SOC(%)'),
						key: 'BeginSoc'
					},
					{
						title: this.$tt('结束SOC(%)'),
						key: 'EndSoc'
					},
					{
						title: this.$tt('充电时长'),
						key: 'ChargeDurationDesc'
					},
					{
						title: this.$tt('充电前电表示值(度)'),
						key: 'MeterBeginReading'
					},
					{
						title: this.$tt('充电后电表示值(度)'),
						key: 'MeterEndReading'
					},
					// {
					// 	title: '退款金额',
					// 	key: 'RefundAmount'
					// },
					// {
					// 	title: '退款状态',
					// 	key: 'RefundStatusDesc'
					// },
					// {
					// 	title: '退款时间',
					// 	key: 'RefundTime'
					// },
					{
						title: this.$tt('停止原因'),
						key: 'TerminateReason'
					},
					// {
					// 	title: '充电卡号',
					// 	key: 'CardNo'
					// },
					// {
					// 	title: '会员手机',
					// 	key: 'MemberPhone'
					// },
					// {
					// 	title: '会员名称',
					// 	key: 'MemberName'
					// },
					{
						title: this.$tt('设备编号'),
						key: 'EquipmentNo'
					},
					{
						title: this.$tt('枪编号'),
						key: 'ConnectorNo'
					},
					{
						title: this.$tt('站点名称'),
						key: 'StationName'
					},
					{
						title: this.$tt('站点运营商'),
						key: 'LocalOperatorName'
					},
				],
				data1: []
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					OrderNo: _this.formInline.OrderNo,
					TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeBegin), 'yyyy-MM-dd'),
					TimeEnd: _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeEnd), 'yyyy-MM-dd'),
					EquipmentNo: _this.formInline.EquipmentNo,
					MemberName: _this.formInline.MemberName
				}
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			//删除修改之外的其他操作
			otherMethod: function(OrderNo) {
				this.$axios.post(webapi.base_api_url + "/Order/PushEvcsOrder", {
					OrderNo: OrderNo,
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.info(this.$tt('事件Id') + OrderNo + this.$tt('推送成功'));
						this.handleSubmit();
					}
				})
			},
			exportFile: function() {
				this.$refs.ChargingOrder.exportCsv({
					filename: '互联互通订单',
					columns: this.columns2,
					data: this.data1.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						// k.StartTime = '\t' + (k.StartTime || '');
						// k.EndTime = '\t' + (k.EndTime || '');
						// k.RefundTime = '\t' + (k.RefundTime || '');
						return k;
					})
				})
			},
			//操作
			show: function(type, params) {
				const _this = this
				switch (type) {
					case "view":
						_this.$refs.echartModal.show(type, params)
						break;
					default:
						break;
				}
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
				// const _this = this;
				// let parms = _this.formInline;
				// _this.$axios.post(webapi.base_api_url + "/Order/GetChargeOrder", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.AlarmingInfos;
				// 	}
				// })
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
